// src/components/MediaSettingsPanel.jsx
import React from "react";
import { useBuilderStore } from "../store/builderStore";

export default function MediaSettingsPanel({ open, onClose, sectionId, question }) {
  const { updateQuestion } = useBuilderStore();

  if (!open || !question) return null;

  const allowComments = question.allowComments ?? true;
  const allowMultiple = question.allowMultiple ?? true;
  const maxFiles = question.maxFiles ?? "";

  const handleUpdate = (payload) => {
    updateQuestion(sectionId, question.id, payload);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex">
      <div className="ml-auto h-full bg-white shadow-xl p-6 w-96 overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">Media Settings</h2>

        {/* Allow multiple uploads */}
        <label className="flex items-center gap-2 mb-4">
          <input
            type="checkbox"
            checked={allowMultiple}
            onChange={() => handleUpdate({ allowMultiple: !allowMultiple })}
          />
          <span>Allow multiple uploads</span>
        </label>

        {/* Allow comments */}
        <label className="flex items-center gap-2 mb-4">
          <input
            type="checkbox"
            checked={allowComments}
            onChange={() => handleUpdate({ allowComments: !allowComments })}
          />
          <span>Allow comments on each file</span>
        </label>

        {/* Maximum files */}
        <div className="mb-5">
          <label className="block mb-1 text-sm font-medium">
            Maximum files (optional)
          </label>
          <input
            type="number"
            min="1"
            placeholder="Unlimited"
            value={maxFiles}
            onChange={(e) =>
              handleUpdate({
                maxFiles: e.target.value ? Number(e.target.value) : "",
              })
            }
            className="w-full border rounded-md p-2 text-sm"
          />
          <p className="text-xs text-gray-500 mt-1">
            Leave blank for unlimited media files.
          </p>
        </div>

        <button
          type="button"
          className="mt-4 px-4 py-2 bg-gray-200 rounded-md text-sm"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
